module.exports = __webpack_public_path__ + "img/BLCA_pDC.8d45dcd6.png";